import { useCallback, useState } from 'react';
import axiosInstance from './axios-config/axios-config';

const useMasterApi = () => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const get = useCallback(async (endpoint) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${endpoint}`);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err.response);
      if (err.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const getWithQueryParams = useCallback(async (endpoint, queryParams) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`${endpoint}`, {
        params: queryParams,
      });
      setData(response.data.data);
      setError(null);
    } catch (err) {
      setError(err.response);
      if (err.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  }, []);


    const post = useCallback(async (endpoint, payload) => {
      setLoading(true);
      try {
        const response = await axiosInstance.post(`${endpoint}`, payload);
        setData(response.data);
        setError(null);
      } catch (err) {
        setError(err.response);
        if (err.response.status === 401) {
          localStorage.clear();
          window.location.reload();
        }
      } finally {
        setLoading(false);
      }
    }, []);

  // const post = useCallback(async (endpoint, payload) => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(`${baseURL}${endpoint}`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(payload),
  //     });
  
  //     if (!response.ok) {
  //       throw new Error('Network response was not ok');
  //     }
  
  //     const data = await response.json();
  //     setData(data);
  //     setError(null);
  //   } catch (err) {
  //     setError(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  const put = useCallback(async (endpoint, payload) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put(`${endpoint}`, payload);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err.response);
      if (err.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const del = useCallback(async (endpoint) => {
    setLoading(true);
    try {
      const response = await axiosInstance.delete(`${endpoint}`);
      setData(response.data);
      setError(null);
    } catch (err) {
      setError(err.response);
      if (err.response.status === 401) {
        localStorage.clear();
        window.location.reload();
      }
    } finally {
      setLoading(false);
    }
  }, []);

  return { get, getWithQueryParams, post, put, deleteService:del, data, error, loading };
};

export default useMasterApi;